import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Cards from 'components/Cards/Cards';
import CardsGroup from 'components/Cards/CardsGroup';

const ComparisonCardSection = ({
  backgroundColor,
  title,
  description,
  cardInfo,
  ...otherProps
}) => {
  return (
    <SectionComparisonCard backgroundColor={backgroundColor} {...otherProps}>
      <div className="section-comparison-card--container">
        <h2 className="section-comparison-card--title">{title}</h2>
        <p className="section-comparison-card--description">{description}</p>
        <div className="section-comparison-card--content">
          {cardInfo?.length > 0 && (
            <CardsGroup cols={3} responsiveMode={'twocolumn'}>
              {cardInfo.map((cardItem, index) => (
                <Cards
                  bodyType="comparison"
                  companyLogo={cardItem.logo}
                  ctaTitle="Learn more"
                  ctaLink={cardItem.link}
                  key={index}
                />
              ))}
            </CardsGroup>
          )}
        </div>
      </div>
    </SectionComparisonCard>
  );
};

ComparisonCardSection.propTypes = {
  title: PropTypes.string,
  awards: PropTypes.array,
};

const SectionComparisonCard = styled.div`
  background: ${props => props.backgroundColor};

  .section-comparison-card--container {
    padding: 80px 28px;
    max-width: 990px;
    margin: 0 auto;
    text-align: center;

    .section-comparison-card--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: var(--normal-title-color);
    }

    .section-comparison-card--description {
      font-weight: 500;
      font-size: 20px;
      line-height: 150%;
      color: var(--normal-description-color);
      padding: 0;
      margin: 24px 0 0;
    }

    .section-comparison-card--content {
      margin-top: 35px;
    }
  }

  @media (max-width: 768px) {
    .section-comparison-card--container {
      padding: 48px 28px;

      .section-comparison-card--title {
        font-size: 29px;
        letter-spacing: -0.03em;
      }

      .section-comparison-card--content {
        margin-top: 17px;
      }
    }
  }

  @media (max-width: 576px) {
    .section-comparison-card--container {
      padding: 48px 20px;

      .section-comparison-card--content {
        margin-top: 17px;
      }
    }
  }
`;

export default ComparisonCardSection;
